import DeleteIcon from "@mui/icons-material/Delete";
import {
  Box,
  Chip,
  Divider,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";

import { getEquipmentTypesDisplay, getServiceTypeDisplayLabel } from "utils";

import { getShipmentTemplateVisibiliyLabel } from "./utils";

import type { ShipmentTemplate } from "types/shipment";

interface Props {
  template: ShipmentTemplate;
  selectedTemplateId: number | null;
  onDeleteTemplate: (template: ShipmentTemplate) => void;
  liProps: React.HTMLAttributes<HTMLLIElement>;
}

export function ShipmentTemplateListElement({
  template,
  selectedTemplateId,
  onDeleteTemplate,
  liProps,
}: Props) {
  const route = template.content?.route ?? [];
  const originCity = route[0]?.point_location?.city;
  const lastRoutePoint = route[route.length - 1];
  const destinationCity =
    route.length > 1 ? lastRoutePoint?.point_location?.city : undefined;
  const visibilityLabel = getShipmentTemplateVisibiliyLabel(template);
  const equipmentTypes = template.content?.equipment_types ?? [];
  const service = template.content?.shipment?.service;

  return (
    <Box
      component="li"
      {...liProps}
      sx={{
        display: "block !important",
        py: 1.5,
        px: 2,
        bgcolor:
          selectedTemplateId === template.id ? "action.selected" : undefined,
        cursor: "pointer",
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        <Stack flex={1} spacing={0.5} minWidth={0}>
          <Typography variant="subtitle2" fontWeight={700}>
            {template.name}
          </Typography>
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            flexWrap="wrap"
          >
            {(originCity || destinationCity) && (
              <Typography variant="body2" color="text.secondary">
                {[originCity, destinationCity].filter(Boolean).join(" → ")}
              </Typography>
            )}
            {equipmentTypes.map((type) => (
              <Chip
                key={type}
                label={getEquipmentTypesDisplay([type])}
                size="small"
              />
            ))}
            {service && (
              <Chip label={getServiceTypeDisplayLabel(service)} size="small" />
            )}
            {visibilityLabel && <Chip label={visibilityLabel} size="small" />}
          </Stack>
        </Stack>
        <Tooltip title="Delete template">
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              onDeleteTemplate(template);
            }}
            aria-label="Delete template"
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Stack>
      <Divider sx={{ mt: 1.5 }} />
    </Box>
  );
}
